module.exports = __webpack_public_path__ + "img/个人中心图.a67b04a7.png";